import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Row, Col, Button, Modal } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { siteLogo as logo } from "../../../const";
import { chatUsers } from "../../../const";
import {
  editMyProfile,
  getMyProfile,
} from "../../../reducers/commonReducer";
import Footer from "../../Sub/Footer";
import NavbarWithDrawer from "../../Sub/NavbarWithDrawer";

const schema = yup.object().shape({
  firstName: yup.string().required(),
});

const UserProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [profileImg, setProfileImg] = useState();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteRequested, setDeleteRequested] = useState(false);

  const { getMyProfileData } = useSelector((state) => state.commonReducer);
  const hasFirstName = Boolean(getMyProfileData?.firstName?.trim());
  const hasLastName = Boolean(getMyProfileData?.lastName?.trim());
  const isForced = localStorage.getItem("slug") === "customer" && !hasFirstName;
  const canEditName =
    localStorage.getItem("slug") === "admin" || !hasFirstName || !hasLastName;
  const isTestBranchUser =
    getMyProfileData?.branch?.name?.toLowerCase() === "testbranch";

  useEffect(() => {
    dispatch(getMyProfile());
  }, [dispatch]);

  return (
    <>
      {/* <CommonHeader /> */}
      <div className="container-fluid">
        {/* {localStorage.getItem("x-auth-token") && (
          <Row className="bg-themesecond shadow-none p-2 align-items-center">
            <Col md={1} sm={1} xs={1}>
              <h4 className="mb-0">
                <LastLocation />
              </h4>
            </Col>
          </Row>
        )} */}
        <NavbarWithDrawer />
        <div className={`mt-5 p-5 mbl-pedding-10`}>
          <Row>
            <Col md={12} className="text-center">
              <div>
                <img
                  className="rounded-circle border shadow user-profile-img"
                  // className={`${width > 468 ? `w-10` : `w-50`}`}
                  src={profileImg || getMyProfileData?.image || logo}
                  alt={process.env.REACT_APP_SITE_NAME}
                />
              </div>
            </Col>
          </Row>
          <Row className="justify-content-between mb-40">
            <Col md={12} className="text-center">
              <h1>
                {getMyProfileData?.firstName
                  ? `${getMyProfileData?.firstName} ${getMyProfileData?.lastName}`
                  : `User Profile`}
              </h1>
            </Col>
          </Row>
          <Row>
            <Col md={4} className="m-auto">
              <Formik
                enableReinitialize
                validationSchema={schema}
                onSubmit={async (values, { resetForm }) => {
                  const apiResp = await dispatch(editMyProfile(values));
                  if (apiResp?.payload?.status) {
                    dispatch(getMyProfile());
                    setProfileImg(undefined);
                    resetForm({
                      values: {
                        ...values,
                        image: "",
                      },
                    });
                    navigate(chatUsers);
                  }
                }}
                initialValues={{
                  firstName: getMyProfileData?.firstName,
                  lastName: getMyProfileData?.lastName,
                  image: "",
                  id: localStorage.getItem("userid"),
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  setFieldValue,
                  touched,
                  values,
                  errors,
                }) => (
                  <Form className="container" onSubmit={handleSubmit}>
                    <Row className="mt-4">
                      <Col md={12} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <label>First Name</label>
                          <Form.Control
                            type="text"
                            placeholder="Enter First Name"
                            name="firstName"
                            value={values.firstName}
                            onChange={handleChange}
                            disabled={!canEditName}
                            isInvalid={!!errors.firstName}
                            className={
                              errors.firstName && touched.firstName && "errors"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.firstName}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mt-2 mb-2">
                      <Col md={12} sm={12}>
                        <Form.Group controlId="validationFormik01">
                          <label>Last Name</label>
                          <Form.Control
                            type="text"
                            placeholder="Last Name"
                            name="lastName"
                            value={values.lastName}
                            onChange={handleChange}
                            disabled={!canEditName}
                            isInvalid={!!errors.lastName}
                            className={
                              errors.lastName && touched.lastName && "errors"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.lastName}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mt-2 mb-2">
                      <Col md={12} sm={12}>
                        <Form.Group>
                          <Form.Label htmlFor="myfile">Profile Image</Form.Label>
                          <Form.Control
                            id="myfile"
                            type="file"
                            name="image"
                            accept="image/*"
                            onChange={(event) => {
                              const userImg = event.target.files[0];
                              setFieldValue("image", userImg);
                              if (userImg) {
                                const previewUrl = URL.createObjectURL(userImg);
                                setProfileImg(previewUrl);
                              } else {
                                setProfileImg(undefined);
                              }
                            }}
                            isInvalid={!!errors.image}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.image}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={12} sm={12}>
                        {isForced && (
                          <div className="alert alert-warning py-2 mb-3">
                            <i className="bi bi-person-fill-exclamation me-2"></i>
                            Please enter your name to continue to chat.
                          </div>
                        )}
                        {!canEditName && (
                          <p className="text-muted small">
                            Only admin can change first name and last name.
                          </p>
                        )}
                        {canEditName && !isForced && localStorage.getItem("slug") !== "admin" && (
                          <p className="text-muted small">
                            You can set your name because it is currently incomplete.
                          </p>
                        )}
                        <Button
                          variant="success"
                          className="bg-thememain w-100 text-black"
                          type="submit"
                        >
                          {isForced ? "Save & Continue" : (localStorage.getItem("x-auth-token") ? "Update" : "Submit")}
                        </Button>
                        {!isForced && isTestBranchUser && (
                          <Button
                            variant="danger"
                            className="w-100 mt-3 text-white fw-semibold"
                            onClick={() => setShowDeleteModal(true)}
                          >
                            <i className="bi bi-trash me-2"></i>Delete Account
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </div>
      </div>
      <Modal show={showDeleteModal} onHide={() => { setShowDeleteModal(false); setDeleteRequested(false); }} centered>
        <Modal.Header closeButton>
          <Modal.Title>{deleteRequested ? "Request Accepted" : "Delete Account"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {deleteRequested ? (
            <div className="text-center py-2">
              <i className="bi bi-check-circle-fill text-success" style={{ fontSize: 48 }}></i>
              <p className="mt-3 mb-1 fw-semibold">Your account deletion request has been accepted.</p>
              <p className="text-muted small mb-0">It will be deleted within 10 to 15 working days. Till then, you can continue using your account.</p>
            </div>
          ) : (
            <>
              <p>Are you sure you want to delete your account?</p>
              <p className="text-muted small mb-0">
                All your chats, uploaded files, history, and other account-related data will be permanently deleted.
              </p>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {deleteRequested ? (
            <Button variant="success" onClick={() => { setShowDeleteModal(false); setDeleteRequested(false); }}>
              OK
            </Button>
          ) : (
            <>
              <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                Cancel
              </Button>
              <Button variant="danger" className="text-white fw-semibold" onClick={() => setDeleteRequested(true)}>
                Yes, Delete My Account
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>

      <Footer />
    </>
  );
};

export default UserProfile;
